export default function escapeUnicodeSurrogatePair(text) {
    return text.replace(new RegExp("[\uD800-\uDBFF][\uDC00-\uDFFF]", "g"), txt => {
        const high = txt.charCodeAt(0);
        const low = txt.charCodeAt(1);
        const codepoint = (((high & 0x03ff) << 10) | (low & 0x03ff)) + 0x10000;
        return `&#${codepoint};`;
    });
}
